import React from "react";
import color from "@fdr/static-ui/ColorPalette";
import styled, { keyframes } from "styled-components";

const pulseAnimation = keyframes`
  0% {
    fill: ${color("grey", "100")};
  }

  50% {
    fill: ${color("grey", "000")};
  }

  100% {
    fill: ${color("grey", "100")};
  }
`;

const Container = styled.div`
  width: 100%;
  overflow: hidden;
  background-color: white;
`;

const SVG = styled.svg`
  display: block;

  rect.pulse {
    animation: ${pulseAnimation} 1.25s infinite;
  }
`;

const TracksAZMask = () => (
  <Container>
    <SVG
      data-qa-label="tracksAZ-loadingMask"
      width="375"
      height="468"
      viewBox="0 0 375 468"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="375" height="48" fill="white" />
      <rect
        className="pulse"
        x="16"
        y="16"
        width="166"
        height="15"
        rx="1"
        fill="#0A0A0A"
      />
      <path d="M0 48H375V76H0V48Z" fill="#F7FBFF" />
      <path
        d="M0 49H375V47H0V49ZM375 75H0V77H375V75Z"
        fill="#EAF0F6"
        mask="url(#path-2-inside-1_31980_141071)"
      />
      <rect
        className="pulse"
        x="16"
        y="56"
        width="14"
        height="12"
        rx="1"
        fill="#0A0A0A"
      />
      <g clipPath="url(#clip0_31980_141071)">
        <rect
          width="375"
          height="48"
          transform="translate(0 76)"
          fill="white"
        />
        <rect
          className="pulse"
          x="16"
          y="92"
          width="16"
          height="16"
          rx="8"
          fill="#0A0A0A"
        />
        <rect
          className="pulse"
          x="40"
          y="92.5"
          width="166"
          height="15"
          rx="1"
          fill="#0A0A0A"
        />
        <rect
          className="pulse"
          x="353"
          y="94"
          width="14"
          height="12"
          rx="1"
          fill="#0A0A0A"
        />
      </g>
      <path
        d="M375 123H0V125H375V123Z"
        fill="#EAF0F6"
        mask="url(#path-5-inside-2_31980_141071)"
      />
      <g clipPath="url(#clip1_31980_141071)">
        <rect
          width="375"
          height="48"
          transform="translate(0 124)"
          fill="white"
        />
        <rect
          className="pulse"
          x="16"
          y="140"
          width="16"
          height="16"
          rx="8"
          fill="#0A0A0A"
        />
        <rect
          className="pulse"
          x="40"
          y="140.5"
          width="166"
          height="15"
          rx="1"
          fill="#0A0A0A"
        />
        <rect
          className="pulse"
          x="353"
          y="142"
          width="14"
          height="12"
          rx="1"
          fill="#0A0A0A"
        />
      </g>
      <path
        d="M375 171H0V173H375V171Z"
        fill="#EAF0F6"
        mask="url(#path-10-inside-3_31980_141071)"
      />
      <path d="M0 172H375V200H0V172Z" fill="#F7FBFF" />
      <path
        d="M375 199H0V201H375V199Z"
        fill="#EAF0F6"
        mask="url(#path-15-inside-4_31980_141071)"
      />
      <rect
        className="pulse"
        x="16"
        y="180"
        width="14"
        height="12"
        rx="1"
        fill="#0A0A0A"
      />
      <g clipPath="url(#clip2_31980_141071)">
        <rect
          width="375"
          height="48"
          transform="translate(0 200)"
          fill="white"
        />
        <rect
          className="pulse"
          x="16"
          y="216"
          width="16"
          height="16"
          rx="8"
          fill="#0A0A0A"
        />
        <rect
          className="pulse"
          x="40"
          y="216.5"
          width="166"
          height="15"
          rx="1"
          fill="#0A0A0A"
        />
        <rect
          className="pulse"
          x="353"
          y="218"
          width="14"
          height="12"
          rx="1"
          fill="#0A0A0A"
        />
      </g>
      <path
        d="M375 247H0V249H375V247Z"
        fill="#EAF0F6"
        mask="url(#path-18-inside-5_31980_141071)"
      />
      <g clipPath="url(#clip3_31980_141071)">
        <rect
          width="375"
          height="48"
          transform="translate(0 248)"
          fill="white"
        />
        <rect
          className="pulse"
          x="16"
          y="264"
          width="16"
          height="16"
          rx="8"
          fill="#0A0A0A"
        />
        <rect
          className="pulse"
          x="40"
          y="264.5"
          width="166"
          height="15"
          rx="1"
          fill="#0A0A0A"
        />
        <rect
          className="pulse"
          x="353"
          y="266"
          width="14"
          height="12"
          rx="1"
          fill="#0A0A0A"
        />
      </g>
      <path
        d="M375 295H0V297H375V295Z"
        fill="#EAF0F6"
        mask="url(#path-23-inside-6_31980_141071)"
      />
      <g clipPath="url(#clip4_31980_141071)">
        <rect
          width="375"
          height="48"
          transform="translate(0 296)"
          fill="white"
        />
        <rect
          className="pulse"
          x="16"
          y="312"
          width="16"
          height="16"
          rx="8"
          fill="#0A0A0A"
        />
        <rect
          className="pulse"
          x="40"
          y="312.5"
          width="166"
          height="15"
          rx="1"
          fill="#0A0A0A"
        />
        <rect
          className="pulse"
          x="353"
          y="314"
          width="14"
          height="12"
          rx="1"
          fill="#0A0A0A"
        />
      </g>
      <path
        d="M375 343H0V345H375V343Z"
        fill="#EAF0F6"
        mask="url(#path-28-inside-7_31980_141071)"
      />
      <path d="M0 344H375V372H0V344Z" fill="#F7FBFF" />
      <path
        d="M375 371H0V373H375V371Z"
        fill="#EAF0F6"
        mask="url(#path-33-inside-8_31980_141071)"
      />
      <rect
        className="pulse"
        x="16"
        y="352"
        width="14"
        height="12"
        rx="1"
        fill="#0A0A0A"
      />
      <g clipPath="url(#clip5_31980_141071)">
        <rect
          width="375"
          height="48"
          transform="translate(0 372)"
          fill="white"
        />
        <rect
          className="pulse"
          x="16"
          y="388"
          width="16"
          height="16"
          rx="8"
          fill="#0A0A0A"
        />
        <rect
          className="pulse"
          x="40"
          y="388.5"
          width="166"
          height="15"
          rx="1"
          fill="#0A0A0A"
        />
        <rect
          className="pulse"
          x="353"
          y="390"
          width="14"
          height="12"
          rx="1"
          fill="#0A0A0A"
        />
      </g>
      <path
        d="M375 419H0V421H375V419Z"
        fill="#EAF0F6"
        mask="url(#path-36-inside-9_31980_141071)"
      />
      <g clipPath="url(#clip6_31980_141071)">
        <rect
          width="375"
          height="48"
          transform="translate(0 420)"
          fill="white"
        />
        <rect
          className="pulse"
          x="16"
          y="436"
          width="16"
          height="16"
          rx="8"
          fill="#0A0A0A"
        />
        <rect
          className="pulse"
          x="40"
          y="436.5"
          width="166"
          height="15"
          rx="1"
          fill="#0A0A0A"
        />
        <rect className="pulse" x="353" y="438" width="14" height="12" rx="1" />
      </g>
      <path
        d="M375 467H0V469H375V467Z"
        fill="#EAF0F6"
        mask="url(#path-41-inside-10_31980_141071)"
      />
    </SVG>
  </Container>
);

export default TracksAZMask;
